import { createFileRoute } from '@tanstack/react-router'
import { requireAdmin } from '@/lib/auth-guards'
import { RutCheckInPage } from '@/features/check-ins/rut-checkin-page'

export const Route = createFileRoute('/_authenticated/check-ins/rut')({
  beforeLoad: requireAdmin,
  component: RutCheckInPage,
})
